import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  heading: 'Details',
  colour: 'Colour',
  dateCreated: 'Date Created',
  deleteButton: 'Delete Category',
})
